import React, { useEffect, useState } from "react";
import { Card, Form, Input, Button, Switch } from "antd";
import { SEOServices } from "../../Services/SEOServices";
import { notify } from "../../customs/NotifyProvider";

const { TextArea } = Input;

const ServicePC = () => {
    const [form] = Form.useForm();
    const [seoData, setSeoData] = useState(null);

    const onFinish = async (values) => {
        console.log("All Form Data:", values);

        try {
            const formattedVal = { content: { ...values }, page_id: 4 };

            let response;

            console.log(seoData);
            

            if (seoData?.id) {
                response = await SEOServices.updatePCDetails(
                    seoData.id,
                    formattedVal
                );
            }
            else {
                response = await SEOServices.addPCDetails(formattedVal);
            }

            if (response?.status) {
                notify.success(response.message);
                getPageSeo();
            } else {
                notify.error(response.message);
            }
        } catch (error) {
            console.error(error);
            notify.error("Something went wrong");
        }
    };

    const getPageSeo = async () => {
        try {
            const response = await SEOServices.getPCDetialById(4);

            if (response?.data?.length > 0) {
                const recordString = response?.data?.[0]?.content;

                const record = recordString ? JSON.parse(recordString) : null;

                console.log(record);

                console.log(response?.data[0]?.content);

                setSeoData(response?.data[0]);        // store existing record
                form.setFieldsValue(record); // populate form
            } else {
                setSeoData(null);
                form.resetFields();
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getPageSeo();
    }, []);



    return (
        <div style={{ padding: 20 }}>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
                initialValues={{
                    sectionStatus: true, // default Active
                }}
            >
                {/* Top Banner Card */}
                <Card title="Top Banner" style={{ marginBottom: 20 }}>
                    <Form.Item
                        label="Banner Image URL"
                        name="bannerImage"
                        rules={[{ required: true, message: "Please input banner image URL!" }]}
                    >
                        <Input placeholder="Enter top banner image URL" />
                    </Form.Item>
                    <Form.Item
                        label="Alt text"
                        name="bannerImage_alt_text"

                    >
                        <Input placeholder="Alt text for image " />
                    </Form.Item>

                    <Form.Item
                        label="Bread curmbs"
                        name="bread_curmbs"
                    >
                        <Input placeholder="Enter Bread Curmbs" />
                    </Form.Item>

                    <Form.Item
                        label="Small Title"
                        name="smallTitle"
                        rules={[{ required: true, message: "Please input small title!" }]}
                    >
                        <Input maxLength={10} placeholder="Enter small title (max 10 chars)" />
                    </Form.Item>

                    <Form.Item
                        label="Main Title"
                        name="mainTitle"
                        rules={[{ required: true, message: "Please input main title!" }]}
                    >
                        <Input placeholder="Enter main title" />
                    </Form.Item>
                </Card>

                {/* Section Content Card */}
                <Card title="Section Content" style={{ marginBottom: 20 }}
                    extra={
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Form.Item
                                name="sectionStatus"
                                valuePropName="checked"
                                style={{ marginBottom: 0 }}
                            >
                                <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
                            </Form.Item>
                        </div>

                    }
                >
                    <Form.Item
                        label="Section Image URL"
                        name="sectionImage"
                    >
                        <Input placeholder="Enter section image URL" />
                    </Form.Item>

                    <Form.Item
                        label="Alt text"
                        name="sectionImage_alt_text"

                    >
                        <Input placeholder="Alt text for image" />
                    </Form.Item>

                    <Form.Item
                        label="Section Title"
                        name="sectionTitle"
                    >
                        <Input placeholder="Enter section title" />
                    </Form.Item>

                    <Form.Item
                        label="Section Subtitle"
                        name="sectionSubtitle"
                    >
                        <TextArea rows={4} placeholder="Enter section subtitle" />
                    </Form.Item>

                    {/* Active / Inactive Toggle */}

                </Card>

                {/* Single Save Button */}
                <Form.Item style={{ textAlign: "right" }}>
                    <Button type="primary" htmlType="submit">
                        Save All Content
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default ServicePC;
